import { render, staticRenderFns } from "./index.vue?vue&type=template&id=282c3ffe&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('282c3ffe')) {
      api.createRecord('282c3ffe', component.options)
    } else {
      api.reload('282c3ffe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=282c3ffe&", function () {
      api.rerender('282c3ffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/molecules/DataDisplayTable/index.vue"
export default component.exports